module.exports = __webpack_public_path__ + "static/media/5ACD6AFF-CAC7-4119-A6D3-E01B71937507.968b8fa5.JPG";